<template>
    <QuestionBaseQuiz :question="question">
        <div>
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body> {{ question.tolerance_info }} </template>
            </AlertMessage>
        </div>

        <div class="mt-1" v-for="index in [0, 1, 2]" :key="index">
            <div class="mt-3 flex gap-1 items-center" v-if="question.options[`label_${index}`]">
                <FormInput
                    :id="`answer_${question.question_id}_${index}`"
                    v-model.trim="answer[`value_${index}`]"
                    :name="`answer_${question.question_id}`"
                    @keypress.enter.prevent
                    type="number"
                    @wheel.passive="$event.target.blur()"
                    step="any"
                    class="mt-1 w-40"
                />
                <label :for="`answer_${question.question_id}_${index}`">
                    <LatexMaybe
                        :model-value="question.options[`label_${index}`]"
                        :is-latex="question.is_latex_answers"
                    />
                </label>
            </div>
        </div>

        <div class="mt-1">
            <button @click="reset" :class="{ invisible: isEmpty }" class="text-gray-600" type="button">
                <IconX class="w-6 h-6 inline-block" />
                {{ $t('messages.delete_answer') }}
            </button>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
export default {
    name: 'QuestionMathMultipleMagnitudesQuiz',
};
</script>
<script setup>
import FormInput from '@/components/Forms/FormInput.vue';
import LatexMaybe from '@/components/LatexMaybe.vue';
import { IconX } from '@tabler/icons-vue';
import { computed, ref, watch } from 'vue';
import AlertMessage from '@/components/AlertMessage.vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';

const props = defineProps({
    question: {
        required: true,
    },
    modelValue: {
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const answer = ref(props.modelValue);

function reset() {
    [0, 1, 2].forEach((i) => {
        if (props.question.options[`label_${i}`]) {
            answer.value[`value_${i}`] = '';
        }
    });
}

const isEmpty = computed(() => {
    return !(answer.value.value_0 || answer.value.value_1 || answer.value.value_2);
});

const stringifiedAnswer = computed(() => {
    if (isEmpty.value) {
        return null;
    } else {
        return JSON.stringify(answer.value);
    }
});

watch(
    () => stringifiedAnswer.value,
    (newVal) => {
        emit('update:modelValue', newVal);
    },
    { immediate: true },
);
</script>
